import "./ConventionAgencySubSection.scss";

export const conventionAgencySubSectionStyles = {
  root: "im-convention-agency-sub-section",
  card: "im-convention-agency-sub-section__card",
};
